// Action Types for Client Management
const P = 'clientManagement/';

// List
export const FETCH_CLIENTS = P + 'FETCH_CLIENTS';
export const FETCH_CLIENTS_SUCCESS = P + 'FETCH_CLIENTS_SUCCESS';
export const FETCH_CLIENTS_FAILURE = P + 'FETCH_CLIENTS_FAILURE';

// Detail
export const FETCH_CLIENT_DETAIL = P + 'FETCH_CLIENT_DETAIL';
export const FETCH_CLIENT_DETAIL_SUCCESS = P + 'FETCH_CLIENT_DETAIL_SUCCESS';
export const FETCH_CLIENT_DETAIL_FAILURE = P + 'FETCH_CLIENT_DETAIL_FAILURE';
export const CLEAR_CLIENT_DETAIL = P + 'CLEAR_CLIENT_DETAIL';

// Create / Update / Delete
export const CREATE_CLIENT = P + 'CREATE_CLIENT';
export const CREATE_CLIENT_SUCCESS = P + 'CREATE_CLIENT_SUCCESS';
export const CREATE_CLIENT_FAILURE = P + 'CREATE_CLIENT_FAILURE';

export const UPDATE_CLIENT = P + 'UPDATE_CLIENT';
export const UPDATE_CLIENT_SUCCESS = P + 'UPDATE_CLIENT_SUCCESS';
export const UPDATE_CLIENT_FAILURE = P + 'UPDATE_CLIENT_FAILURE';

export const DELETE_CLIENT = P + 'DELETE_CLIENT';
export const DELETE_CLIENT_SUCCESS = P + 'DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAILURE = P + 'DELETE_CLIENT_FAILURE';

// Websites
export const ADD_CLIENT_WEBSITE = P + 'ADD_CLIENT_WEBSITE';
export const ADD_CLIENT_WEBSITE_SUCCESS = P + 'ADD_CLIENT_WEBSITE_SUCCESS';
export const UPDATE_CLIENT_WEBSITE = P + 'UPDATE_CLIENT_WEBSITE';
export const UPDATE_CLIENT_WEBSITE_SUCCESS = P + 'UPDATE_CLIENT_WEBSITE_SUCCESS';
export const DELETE_CLIENT_WEBSITE = P + 'DELETE_CLIENT_WEBSITE';
export const DELETE_CLIENT_WEBSITE_SUCCESS = P + 'DELETE_CLIENT_WEBSITE_SUCCESS';

// Work Periods
export const ADD_CLIENT_PERIOD = P + 'ADD_CLIENT_PERIOD';
export const ADD_CLIENT_PERIOD_SUCCESS = P + 'ADD_CLIENT_PERIOD_SUCCESS';
export const UPDATE_CLIENT_PERIOD = P + 'UPDATE_CLIENT_PERIOD';
export const UPDATE_CLIENT_PERIOD_SUCCESS = P + 'UPDATE_CLIENT_PERIOD_SUCCESS';
export const DELETE_CLIENT_PERIOD = P + 'DELETE_CLIENT_PERIOD';
export const DELETE_CLIENT_PERIOD_SUCCESS = P + 'DELETE_CLIENT_PERIOD_SUCCESS';

// Git Repos
export const ADD_CLIENT_GIT_REPO = P + 'ADD_CLIENT_GIT_REPO';
export const ADD_CLIENT_GIT_REPO_SUCCESS = P + 'ADD_CLIENT_GIT_REPO_SUCCESS';
export const UPDATE_CLIENT_GIT_REPO = P + 'UPDATE_CLIENT_GIT_REPO';
export const UPDATE_CLIENT_GIT_REPO_SUCCESS = P + 'UPDATE_CLIENT_GIT_REPO_SUCCESS';
export const DELETE_CLIENT_GIT_REPO = P + 'DELETE_CLIENT_GIT_REPO';
export const DELETE_CLIENT_GIT_REPO_SUCCESS = P + 'DELETE_CLIENT_GIT_REPO_SUCCESS';

// Stack
export const ADD_CLIENT_STACK = P + 'ADD_CLIENT_STACK';
export const ADD_CLIENT_STACK_SUCCESS = P + 'ADD_CLIENT_STACK_SUCCESS';
export const UPDATE_CLIENT_STACK = P + 'UPDATE_CLIENT_STACK';
export const UPDATE_CLIENT_STACK_SUCCESS = P + 'UPDATE_CLIENT_STACK_SUCCESS';
export const DELETE_CLIENT_STACK = P + 'DELETE_CLIENT_STACK';
export const DELETE_CLIENT_STACK_SUCCESS = P + 'DELETE_CLIENT_STACK_SUCCESS';

// Employees
export const ASSIGN_EMPLOYEE = P + 'ASSIGN_EMPLOYEE';
export const ASSIGN_EMPLOYEE_SUCCESS = P + 'ASSIGN_EMPLOYEE_SUCCESS';
export const UPDATE_EMPLOYEE_ASSIGNMENT = P + 'UPDATE_EMPLOYEE_ASSIGNMENT';
export const UPDATE_EMPLOYEE_ASSIGNMENT_SUCCESS = P + 'UPDATE_EMPLOYEE_ASSIGNMENT_SUCCESS';
export const UNASSIGN_EMPLOYEE = P + 'UNASSIGN_EMPLOYEE';
export const UNASSIGN_EMPLOYEE_SUCCESS = P + 'UNASSIGN_EMPLOYEE_SUCCESS';

// Teams
export const ASSIGN_TEAM = P + 'ASSIGN_TEAM';
export const ASSIGN_TEAM_SUCCESS = P + 'ASSIGN_TEAM_SUCCESS';
export const UNASSIGN_TEAM = P + 'UNASSIGN_TEAM';
export const UNASSIGN_TEAM_SUCCESS = P + 'UNASSIGN_TEAM_SUCCESS';
export const FETCH_TEAM_OPTIONS = P + 'FETCH_TEAM_OPTIONS';
export const FETCH_TEAM_OPTIONS_SUCCESS = P + 'FETCH_TEAM_OPTIONS_SUCCESS';
export const FETCH_TEAM_OPTIONS_FAILURE = P + 'FETCH_TEAM_OPTIONS_FAILURE';

// Created entity navigation
export const CLEAR_LAST_CREATED_CLIENT = P + 'CLEAR_LAST_CREATED_CLIENT';

// UI state
export const OPEN_CLIENT_DIALOG = P + 'OPEN_CLIENT_DIALOG';
export const CLOSE_CLIENT_DIALOG = P + 'CLOSE_CLIENT_DIALOG';
export const OPEN_DELETE_DIALOG = P + 'OPEN_DELETE_DIALOG';
export const CLOSE_DELETE_DIALOG = P + 'CLOSE_DELETE_DIALOG';
export const OPEN_DETAIL_DIALOG = P + 'OPEN_DETAIL_DIALOG';
export const CLOSE_DETAIL_DIALOG = P + 'CLOSE_DETAIL_DIALOG';

export const SET_FILTERS = P + 'SET_FILTERS';
export const SET_PAGINATION = P + 'SET_PAGINATION';
export const SET_SORT = P + 'SET_SORT';

// Employee dropdown options
export const FETCH_EMPLOYEE_OPTIONS = P + 'FETCH_EMPLOYEE_OPTIONS';
export const FETCH_EMPLOYEE_OPTIONS_SUCCESS = P + 'FETCH_EMPLOYEE_OPTIONS_SUCCESS';
export const FETCH_EMPLOYEE_OPTIONS_FAILURE = P + 'FETCH_EMPLOYEE_OPTIONS_FAILURE';
